import { render, staticRenderFns } from "./DossierDocumentsActions.vue?vue&type=template&id=ed2903bc&scoped=true"
import script from "./DossierDocumentsActions.vue?vue&type=script&lang=ts"
export * from "./DossierDocumentsActions.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed2903bc",
  null
  
)

export default component.exports